import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { NOT_FOUND } from '../../actions/auth';
import { PAGE_URL } from '../../../utils/constants';
import { querySyncPush } from '../../actions/navigation';

export default action$ => action$.pipe(
  ofType(NOT_FOUND),
  map(() => querySyncPush(PAGE_URL.NOT_FOUND))
);